export default __webpack_public_path__ + "static/media/9981825A-6D47-4384-B53B-E0E279B57D97_1_105_c.16d829f8.jpeg";